<template>
  <div class="empty-folder">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="150"
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        opacity="0.48"
        d="M60.0001 78.9487C59.9186 93.3254 59.7552 115.324 59.9994 115.367C60.3628 115.367 60.7263 115.314 61.0783 115.209L94.8283 105.084C95.6007 104.853 96.2779 104.378 96.7592 103.731C97.2405 103.084 97.5003 102.298 97.5001 101.492V66.7819L60.0001 78.9487Z"
        fill="#ff002f"
      />
      <path
        opacity="0.48"
        d="M59.9217 78.9233L22.5002 66.7819L22.5 101.492C22.4998 102.298 22.7597 103.083 23.241 103.731C23.7223 104.378 24.3994 104.852 25.1719 105.084L58.9219 115.209C59.2734 115.314 59.6365 115.367 59.9996 115.367C59.7549 115.345 59.84 93.3069 59.9217 78.9233Z"
        fill="#eb8890"
      />
      <path
        opacity="0.8"
        d="M60 78.9487L22.5001 66.7819L12.9844 80.8894C12.8218 81.1301 12.7173 81.4054 12.6792 81.6934C12.6412 81.9815 12.6706 82.2744 12.7651 82.5492C12.8597 82.8239 13.0168 83.0729 13.2241 83.2765C13.4313 83.4801 13.6831 83.6328 13.9594 83.7225L47.7001 94.6837C48.0866 94.8094 48.5036 94.8061 48.8881 94.6742C49.2726 94.5423 49.6039 94.289 49.8319 93.9525L60 78.9487Z"
        fill="url(#paint0_linear_2734_145270)"
      />
      <path
        opacity="0.8"
        d="M97.5 66.7819L60 78.9487L70.1681 93.9525C70.3962 94.289 70.7274 94.5423 71.1119 94.6742C71.4964 94.8061 71.9134 94.8094 72.3 94.6837L106.041 83.7225C106.317 83.6328 106.569 83.4801 106.776 83.2765C106.983 83.0729 107.14 82.8239 107.235 82.5492C107.329 82.2744 107.359 81.9815 107.321 81.6934C107.283 81.4054 107.178 81.1301 107.016 80.8894L97.5 66.7819Z"
        fill="url(#paint1_linear_2734_145270)"
      />
      <path
        opacity="0.64"
        d="M50.92 41.8196C50.6915 41.4841 50.3603 41.2318 49.9763 41.1006C49.5922 40.9695 49.1759 40.9664 48.79 41.0921L15.0475 52.0552C14.7709 52.1443 14.5189 52.2966 14.3114 52.4999C14.1039 52.7033 13.9466 52.9523 13.852 53.227C13.7574 53.5017 13.728 53.7947 13.7663 54.0827C13.8046 54.3708 13.9094 54.6459 14.0725 54.8864L22.4968 67.3777L59.9968 55.1696L50.92 41.8196Z"
        fill="url(#paint2_linear_2734_145270)"
      />
      <path
        opacity="0.64"
        d="M105.924 54.2906C106.087 54.0499 106.191 53.7748 106.229 53.487C106.267 53.1991 106.237 52.9065 106.142 52.632C106.048 52.3575 105.891 52.1087 105.684 51.9052C105.477 51.7017 105.225 51.5491 104.949 51.4594L71.2069 40.4962C70.8209 40.3706 70.4047 40.3736 70.0206 40.5048C69.6365 40.636 69.3053 40.8883 69.0769 41.2237L60 54.5737L97.5 66.7819L105.924 54.2906Z"
        fill="url(#paint3_linear_2734_145270)"
      />
      <path
        opacity="0.48"
        d="M97.5 66.7819L60 54.5737L22.5 66.7819L60 78.9487L97.5 66.7819Z"
        fill="#ff002f"
      />
      <path
        opacity="0.48"
        d="M60 66.6763V55L22.5 67.2081L60 79.375V66.6763Z"
        fill="#ff002f"
      />
      <path
        d="M57.9995 12.8081C60.0283 1.31999 77.6101 2.06249 67.3745 12.8081H57.9995Z"
        fill="#bd0006"
        fill-opacity="0.12"
      />
      <path
        d="M57.9995 15.7181C60.0283 27.2044 77.6101 26.4637 67.3745 15.7181H57.9995Z"
        fill="#bd0006"
        fill-opacity="0.12"
      />
      <path
        d="M52.4664 59.9587C51.721 59.4742 51.0162 58.9299 50.3589 58.3312C49.9904 58.0092 49.5106 57.844 49.022 57.8708C48.5334 57.8977 48.0746 58.1146 47.7437 58.4751C47.4128 58.8357 47.2359 59.3113 47.2509 59.8005C47.2659 60.2896 47.4715 60.7535 47.8239 61.0931C48.5908 61.7981 49.4552 62.4694 50.4152 63.0975C50.8314 63.3607 51.3344 63.4496 51.8156 63.3451C52.2968 63.2405 52.7176 62.9508 52.987 62.5386C53.2564 62.1263 53.3528 61.6247 53.2554 61.142C53.158 60.6593 52.8746 60.2342 52.4664 59.9587ZM46.6239 54.1987C46.0911 53.4807 45.6182 52.72 45.2102 51.9244C44.9847 51.481 44.5923 51.1455 44.1193 50.9914C43.6464 50.8374 43.1316 50.8776 42.6883 51.1031C42.245 51.3286 41.9094 51.721 41.7554 52.194C41.6014 52.6669 41.6415 53.1817 41.867 53.625C42.3433 54.5587 42.9208 55.4944 43.6052 56.4225C43.9037 56.8128 44.3436 57.0703 44.8301 57.1396C45.3166 57.2089 45.8109 57.0844 46.2065 56.793C46.6022 56.5015 46.8676 56.0664 46.9457 55.5812C47.0237 55.096 46.9082 54.5996 46.6239 54.1987ZM43.8827 46.5469C43.9014 45.7912 44.012 45.0581 44.2145 44.355C44.2824 44.1182 44.3029 43.8704 44.275 43.6258C44.2471 43.3811 44.1712 43.1443 44.0518 42.9289C43.9323 42.7135 43.7716 42.5238 43.5789 42.3705C43.3861 42.2173 43.165 42.1034 42.9283 42.0356C42.6915 41.9678 42.4438 41.9472 42.1991 41.9752C41.9544 42.0031 41.7176 42.0789 41.5022 42.1984C41.2868 42.3178 41.0971 42.4785 40.9438 42.6713C40.7906 42.864 40.6768 43.0851 40.6089 43.3219C40.3189 44.3414 40.1589 45.3935 40.1327 46.4531C40.1202 46.9504 40.3059 47.4322 40.6487 47.7927C40.9915 48.1531 41.4635 48.3626 41.9608 48.375C42.4581 48.3874 42.9399 48.2018 43.3003 47.859C43.6608 47.5161 43.8702 47.0441 43.8827 46.5469ZM46.7664 40.2844C47.2483 39.8381 47.7883 39.4256 48.3789 39.0525C48.5872 38.9211 48.7676 38.75 48.9098 38.5489C49.052 38.3479 49.1532 38.1207 49.2076 37.8806C49.262 37.6404 49.2686 37.3918 49.2269 37.1491C49.1853 36.9064 49.0962 36.6742 48.9649 36.4659C48.8335 36.2576 48.6624 36.0772 48.4613 35.935C48.2602 35.7929 48.0331 35.6917 47.7929 35.6373C47.5527 35.5829 47.3042 35.5763 47.0615 35.6179C46.8187 35.6596 46.5866 35.7486 46.3783 35.88C45.6088 36.3634 44.8857 36.917 44.2183 37.5337C43.8627 37.8739 43.6551 38.3402 43.6403 38.832C43.6254 39.3239 43.8045 39.8018 44.1389 40.1628C44.4733 40.5238 44.9363 40.7389 45.4278 40.7616C45.9193 40.7843 46.4001 40.6129 46.7664 40.2844ZM53.7395 37.05C54.7292 36.8692 55.7305 36.7589 56.7358 36.72C57.2209 36.6825 57.6725 36.4582 57.9954 36.0942C58.3183 35.7302 58.4872 35.2551 58.4665 34.7689C58.4459 34.2828 58.2372 33.8237 57.8846 33.4885C57.532 33.1532 57.063 32.968 56.5764 32.9719C55.3389 33.0244 54.1652 33.1575 53.057 33.3619C52.568 33.4524 52.1349 33.7334 51.853 34.1433C51.5712 34.5531 51.4637 35.0581 51.5542 35.5472C51.6447 36.0362 51.9258 36.4693 52.3356 36.7512C52.7455 37.033 53.2505 37.1405 53.7395 37.05ZM63.512 36.9394C65.1114 36.9581 66.6002 36.9019 67.982 36.78C68.4728 36.7303 68.9242 36.4892 69.2384 36.1089C69.5527 35.7287 69.7044 35.2399 69.6607 34.7486C69.6171 34.2572 69.3816 33.8029 69.0052 33.484C68.6289 33.1651 68.142 33.0074 67.6502 33.045C66.3845 33.1556 65.0214 33.2081 63.5552 33.1894C63.0579 33.1836 62.5787 33.3757 62.223 33.7233C61.8674 34.0709 61.6643 34.5455 61.6586 35.0428C61.6529 35.5401 61.8449 36.0193 62.1925 36.3749C62.5401 36.7306 63.0148 36.9336 63.512 36.9394ZM74.1452 35.6306C76.0014 35.0625 77.5689 34.335 78.8814 33.5006C79.0891 33.3683 79.2687 33.1963 79.4099 32.9945C79.5512 32.7928 79.6513 32.5652 79.7046 32.3247C79.7578 32.0843 79.7632 31.8357 79.7205 31.5932C79.6777 31.3507 79.5875 31.1189 79.4552 30.9112C79.3228 30.7035 79.1509 30.5239 78.9491 30.3827C78.7473 30.2415 78.5198 30.1414 78.2793 30.0881C78.0389 30.0348 77.7903 30.0294 77.5477 30.0722C77.3052 30.115 77.0735 30.2051 76.8658 30.3375C75.6758 31.0753 74.3917 31.6493 73.0483 32.0437C72.5726 32.1892 72.1743 32.5176 71.9408 32.9568C71.7073 33.396 71.6578 33.91 71.8033 34.3856C71.9487 34.8613 72.2772 35.2596 72.7164 35.4931C73.1556 35.7266 73.6695 35.7761 74.1452 35.6306ZM83.6889 28.2525C84.5326 26.5001 84.9239 24.5643 84.827 22.6219C84.8156 22.3759 84.7558 22.1346 84.6511 21.9117C84.5464 21.6888 84.3988 21.4887 84.2168 21.3229C84.0347 21.1571 83.8218 21.0287 83.5902 20.9451C83.3585 20.8616 83.1127 20.8245 82.8667 20.8359C82.6207 20.8474 82.3794 20.9072 82.1565 21.0119C81.9337 21.1166 81.7336 21.2642 81.5678 21.4462C81.4019 21.6282 81.2736 21.8411 81.19 22.0728C81.1065 22.3044 81.0693 22.5503 81.0808 22.7962C81.1482 24.1154 80.8839 25.4305 80.312 26.6212C80.1207 27.0655 80.1082 27.5665 80.2773 28.0197C80.4463 28.4729 80.7839 28.8434 81.2194 29.0538C81.655 29.2642 82.155 29.2983 82.6151 29.149C83.0752 28.9997 83.4599 28.6785 83.6889 28.2525ZM82.4945 15.9919C81.1277 14.145 79.2733 12.8587 77.252 12.4444C76.7723 12.3632 76.2798 12.4714 75.8784 12.7463C75.477 13.0212 75.198 13.4412 75.1002 13.9178C75.0024 14.3944 75.0936 14.8904 75.3544 15.3011C75.6152 15.7118 76.0254 16.0052 76.4983 16.1194C77.6645 16.3575 78.692 17.1581 79.4814 18.225C79.628 18.4228 79.8122 18.5899 80.0234 18.7165C80.2346 18.8432 80.4686 18.927 80.7122 18.9633C80.9558 18.9995 81.2041 18.9874 81.443 18.9276C81.6819 18.8678 81.9067 18.7616 82.1045 18.615C82.3024 18.4684 82.4694 18.2842 82.5961 18.073C82.7228 17.8618 82.8066 17.6278 82.8428 17.3842C82.879 17.1406 82.8669 16.8923 82.8072 16.6534C82.7474 16.4145 82.6412 16.1897 82.4945 15.9919Z"
        fill="#bd0006"
        fill-opacity="0.24"
      />
      <path
        d="M57.8308 16.1569H70.3858C70.8831 16.1569 71.36 15.9593 71.7116 15.6077C72.0632 15.2561 72.2608 14.7791 72.2608 14.2819C72.2608 13.7846 72.0632 13.3077 71.7116 12.956C71.36 12.6044 70.8831 12.4069 70.3858 12.4069H57.8308C57.348 12.4285 56.8922 12.6354 56.5582 12.9847C56.2242 13.334 56.0378 13.7986 56.0378 14.2819C56.0378 14.7651 56.2242 15.2298 56.5582 15.579C56.8922 15.9283 57.348 16.1353 57.8308 16.1569Z"
        fill="#bd0006"
        fill-opacity="0.24"
      />
      <defs fill="#ffffff">
        <linearGradient
          id="paint0_linear_2734_145270"
          x1="22.7494"
          y1="66.7669"
          x2="27.9905"
          y2="101.442"
          gradientUnits="userSpaceOnUse"
          fill="#ffffff"
        >
          <stop stop-color="#F4F6F8" fill="#ffffff" />
          <stop offset="1" stop-color="#ff002f" fill="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2734_145270"
          x1="60.1519"
          y1="78.8212"
          x2="99.6838"
          y2="101.557"
          gradientUnits="userSpaceOnUse"
          fill="#ffffff"
        >
          <stop stop-color="#F4F6F8" fill="#ffffff" />
          <stop offset="1" stop-color="#ff002f" fill="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2734_145270"
          x1="17.5881"
          y1="60.1008"
          x2="23.245"
          y2="33.434"
          gradientUnits="userSpaceOnUse"
          fill="#ffffff"
        >
          <stop stop-color="#F4F6F8" fill="#ffffff" />
          <stop offset="1" stop-color="#ff002f" fill="#ffffff" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2734_145270"
          x1="70.0387"
          y1="40.0444"
          x2="72.0615"
          y2="72.9595"
          gradientUnits="userSpaceOnUse"
          fill="#ffffff"
        >
          <stop stop-color="#F4F6F8" fill="#ffffff" />
          <stop offset="1" stop-color="#ff002f" fill="#ffffff" />
        </linearGradient>
      </defs>
    </svg>
    <span class="empty-upper-text-msg">Nada a exibir</span>
    <span class="empty-lower-text-msg">Ainda não há mensagens nesta caixa</span>
  </div>
</template>
<style scoped>
.mailbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  transition: all 0.3s;
  scrollbar-width: thin;
  scrollbar-color: #f5f6fa #dde1ed;
  overflow-y: auto;
  z-index: 5;
}

@media (prefers-reduced-motion: reduce) {
  .mailbox {
    transition: none;
  }
}

@media (min-width: 768px) {
  .mailbox {
    left: 240px;
    width: auto;
    right: 0;
  }
}

@media (min-width: 1200px) {
  .mailbox {
    width: 390px;
    right: auto;
  }
}

.loader-animation {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mailbox-header {
  display: flex;
  align-items: center;
  padding: 10px;
  position: relative;
}

@media (min-width: 768px) {
  .mailbox-header {
    padding: 20px 20px 10px;
  }
}

.mailbox-header .mail-avatar {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 10;
  display: block;
  text-decoration: none;
}

@media (min-width: 768px) {
  .mailbox-header .mail-avatar {
    top: 28px;
    right: 30px;
  }
}

.mailbox-header .mail-avatar span {
  background-color: #dc0f37;
  font-size: 14px;
}

.mailbox-menu {
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
  margin-right: 10px;
  text-decoration: none;
  text-indent: -2px;
  color: #343740;
}

@media (min-width: 768px) {
  .mailbox-menu {
    margin-left: 0;
    margin-right: 15px;
  }
}

.mailbox-menu:hover,
.mailbox-menu:focus {
  color: #dc0f37;
}

.mailbox-menu i {
  font-size: 24px;
  line-height: 1;
}

.mailbox-search {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 10px;
  background-color: #fff;
  border: 1px solid #dde1ed;
  border-radius: 5px;
  box-shadow: 0 1px 1px rgba(221, 225, 237, 0.25),
    0 2px 2px rgba(221, 225, 237, 0.2), 0 4px 4px rgba(221, 225, 237, 0.15),
    0 8px 8px rgba(221, 225, 237, 0.1), 0 16px 16px rgba(221, 225, 237, 0.05);
}

.mailbox-search i {
  font-size: 20px;
  line-height: 1;
  color: #6b748f;
  margin-top: -2px;
}

.mailbox-search .form-control {
  flex: 1;
  background-color: transparent;
  border-width: 0;
  font-size: 14px;
  padding-left: 8px;
  padding-top: 5px;
}

.mailbox-search .form-control:focus {
  box-shadow: none;
}

.mailbox-search .form-control::placeholder {
  color: #a1a8bb;
  text-shadow: none;
}

.mailbox-option {
  padding: 5px 10px 10px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

@media (min-width: 768px) {
  .mailbox-option {
    padding: 5px 20px 15px;
  }
}

.mailbox-option span {
  margin-right: 10px;
  color: #a1a8bb;
  font-size: 12px;
  letter-spacing: 0.2px;
}

.mailbox-option .pager {
  position: relative;
  width: 28px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #cccfd9;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  color: #6b748f;
  text-decoration: none;
  box-shadow: 0 1px 1px rgba(233, 234, 240, 0.25),
    0 2px 2px rgba(233, 234, 240, 0.2), 0 4px 4px rgba(233, 234, 240, 0.15),
    0 8px 8px rgba(233, 234, 240, 0.1), 0 16px 16px rgba(233, 234, 240, 0.05);
  cursor: pointer;
  margin-left: 5px;
}

.mailbox-option .pager:hover,
.mailbox-option .pager:focus {
  background-color: #e9ecf3;
}

.mailbox-option .pager i {
  font-size: 22px;
  line-height: 1;
}

.mailbox-option .pager + .pager {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.mailbox-select {
  display: flex;
  margin-left: 10px;
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 1px rgba(233, 234, 240, 0.25),
    0 2px 2px rgba(233, 234, 240, 0.2), 0 4px 4px rgba(233, 234, 240, 0.15),
    0 8px 8px rgba(233, 234, 240, 0.1), 0 16px 16px rgba(233, 234, 240, 0.05);
}

.mailbox-select .dropdown-check {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cccfd9;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  color: #6b748f;
  text-decoration: none;
}

.mailbox-select .dropdown-check:hover,
.mailbox-select .dropdown-check:focus {
  background-color: #f0f2f7;
}

.mailbox-select .dropdown-check i {
  font-size: 18px;
  line-height: 1;
  border-radius: 2px;
}

.mailbox-select .dropdown-check i:not(:first-child) {
  display: none;
}

.mailbox-select .dropdown-check.checkall i {
  color: #dc0f37;
}

.mailbox-select .dropdown-check.checkall i:first-child {
  display: none;
}

.mailbox-select .dropdown-check.checkall i:nth-child(2) {
  display: block;
}

.mailbox-select .dropdown-check.checkall i:last-child {
  display: none;
}

.mailbox-select .dropdown-check.check i {
  color: #dc0f37;
}

.mailbox-select .dropdown-check.check i:first-child,
.mailbox-select .dropdown-check.check i:nth-child(2) {
  display: none;
}

.mailbox-select .dropdown-check.check i:last-child {
  display: block;
}

.mailbox-select .dropdown-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 32px;
  text-decoration: none;
  color: #6b748f;
  font-size: 18px;
  border: 1px solid #cccfd9;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  margin-left: -1px;
}

.mailbox-select .dropdown-link:hover,
.mailbox-select .dropdown-link:focus {
  background-color: #f0f2f7;
}

.mailbox-select .dropdown-menu {
  margin-top: 2px !important;
  width: 180px;
  padding: 5px;
  border-color: rgba(33, 35, 41, 0.12);
  border-radius: 5px;
  box-shadow: 0 1px 1px rgba(204, 207, 217, 0.08),
    0 2px 2px rgba(204, 207, 217, 0.12), 0 4px 4px rgba(204, 207, 217, 0.16),
    0 8px 8px rgba(204, 207, 217, 0.2);
}

.mailbox-select .dropdown-item {
  font-size: 14px;
  color: #212329;
  padding: 6px 8px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

.mailbox-select .dropdown-item + .dropdown-item {
  margin-top: 1px;
}

.mailbox-select .dropdown-item:hover {
  background-color: #f5f6fa;
}

.mailbox-select .dropdown-item i {
  font-size: 16px;
  line-height: 1.2px;
  margin-right: 7px;
  opacity: 0;
}

.mailbox-select .dropdown-item.active {
  background-color: #edf1fe;
  color: #dc0f37;
}

.mailbox-select .dropdown-item.active i {
  opacity: 1;
}

.mail-group {
  position: relative;
  padding: 0 10px;
  margin: 0;
  list-style: none;
  height: calc(100vh - 115px);
  overflow-y: auto;
}

@media (min-width: 768px) {
  .mail-group {
    padding: 0 20px;
    height: calc(100vh - 130px);
  }
}

.mail-item {
  position: relative;
  min-height: 100px;
  border-radius: 5px;
  padding: 10px 10px 12px;
  background-color: #f5f6fa;
  border: 1px solid transparent;
  display: flex;
  overflow: hidden;
}

.mail-item:last-of-type {
  margin-bottom: 3px;
}

.mail-item + .mail-item {
  margin-top: 2px;
}

.mail-item:hover,
.mail-item:focus {
  cursor: pointer;
  z-index: 6;
  border-color: rgba(118, 149, 245, 0.6);
  background-color: rgba(245, 246, 250, 0.6);
}

.mail-item.unread {
  background-color: #fff;
}

.mail-item.unread .mail-sender,
.mail-item.unread .mail-time {
  font-weight: 500;
  color: #212329;
}

.mail-item.unread .mail-subject {
  font-weight: 500;
  color: #212329;
}

@media (min-width: 768px) {
  .mail-item.active {
    z-index: 5;
    background-color: rgba(255, 255, 255, 0.75);
    border-color: #7695f5;
    box-shadow: 0 1px 1px rgba(204, 207, 217, 0.25),
      0 2px 2px rgba(204, 207, 217, 0.2), 0 4px 4px rgba(204, 207, 217, 0.15),
      0 8px 8px rgba(204, 207, 217, 0.1), 0 16px 16px rgba(204, 207, 217, 0.05);
  }
}

.mail-item.selected {
  background-color: #e8edfd;
}

.mail-avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 100%;
}

.mail-avatar img {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.mail-item-body {
  flex: 1;
  padding-left: 15px;
}

.mail-item-body > div:first-child {
  margin-bottom: 2px;
}

.mail-sender {
  font-size: 12px;
  margin-right: auto;
}

.mail-time {
  font-size: 11px;
  color: #a1a8bb;
  margin-right: 25px;
}

.mail-star:hover,
.mail-star:focus {
  color: #ffc107;
}

.mail-star i:last-child {
  display: none;
}

.mail-star.active {
  color: #ffc107;
}

.mail-star.active i:first-child {
  display: none;
}

.mail-star.active i:last-child {
  display: inline;
}

.mail-subject {
  font-size: 14px;
  font-weight: 400;
  color: #212329;
  margin-bottom: 5px;
}

.mail-subject span {
  font-weight: 300;
  color: #a1a8bb;
}

.mail-text {
  margin-bottom: 0;
  color: #6b748f;
  font-size: 13px;
}

.mail-star {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  top: 0.5px;
  line-height: 1;
}

.mail-new {
  height: 9px;
  width: 9px;
}

.ri-star-line,
.ri-star-fill {
  font-size: 13px;
}

.tag {
  color: white;
  padding: 3px;
  margin: 3px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  text-align: center;
  float: left;
}
.tag span {
  padding: 0px 5px;
  font-size: 12px;
}

.presentation {
  background-color: rgb(255 0 174 / 50%);
}

.referral {
  background-color: rgba(0, 38, 255, 0.5);
}

.mailing_exclusion {
  background-color: rgba(255, 0, 0, 0.5);
}

.prospecting {
  background-color: rgba(255, 145, 0, 0.5);
}

.scheduling {
  background-color: rgba(0, 255, 0, 0.5);
}

.no_interest {
  background-color: rgba(128, 128, 128, 1);
}

.selected-options {
  cursor: pointer;
  display: flex;
  margin-left: 6px;
}

.selected-amount {
  margin-left: 10px;
}

.empty-folder {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 243px;
}

.empty-upper-text-msg {
  color: #919eab;
  font-weight: 600;
  line-height: 1.55556;
  text-align: center;
  margin: 8px 0px 0px;
  font-size: 1.0625rem;
}

.empty-lower-text-msg {
  margin: 8px 0px 0px;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.5;
  text-align: center;
  color: #919eab;
}
</style>
